import { doc, runTransaction, Timestamp } from "@firebase/firestore";
import { SCREEN_VISIT_KEYS } from "@/service/screenVisits";

const NON_ABANDONMENT_SCREENS = new Set([
  "pagamento", "pagamento_sucesso", "impressao", "agradecimento",
]);

export function canRecordTimeoutAbandonment(compra, path) {
  const tela = SCREEN_VISIT_KEYS[path];
  return Boolean(
    compra?.id && tela && !NON_ABANDONMENT_SCREENS.has(tela) &&
      compra.pago !== true && !compra.pago_em && !compra.impressao_confirmada_em &&
      !["PAGAMENTO_PROCESSO", "PAGAMENTO_SUCESSO", "IMPRESSAO", "AGRADECIMENTO", "CONCLUIDO", "CANCELADA"].includes(compra.etapa)
  );
}

// O timeout nunca regrava o objeto completo da store: ele pode estar atrasado
// em relação à aprovação. A etapa e a telemetria são escritas juntas somente
// após conferir a compra remota; campos financeiros nunca entram na escrita.
export async function expirePurchaseByTimeout(
  db, path, compraId, totemId, endedAt = new Date(), isCurrent = () => true
) {
  if (!totemId || !isCurrent() || !canRecordTimeoutAbandonment({ id: compraId }, path)) return false;
  const compraRef = doc(db, "compras", compraId);
  const totemRef = doc(db, "totem", totemId);
  const em = Timestamp.fromDate(endedAt);
  return runTransaction(db, async (transaction) => {
    if (!isCurrent()) return false;
    const snapshot = await transaction.get(compraRef);
    if (!isCurrent() || !snapshot.exists()) return false;
    const compra = { ...snapshot.data(), id: compraId };
    if (compra.totem_id !== totemId || compra.abandono_timeout ||
      !canRecordTimeoutAbandonment(compra, path)) {
      return false;
    }
    const totem = await transaction.get(totemRef);
    if (!isCurrent()) return false;
    transaction.update(compraRef, {
      etapa: "EXPIROU",
      abandono_timeout_versao: 1,
      abandono_timeout: { versao: 1, tela: SCREEN_VISIT_KEYS[path], em },
      // A jornada terminou neste instante. O recorte diário existente usa
      // keep_alive; gravá-lo junto ao marcador fixa o dia do encerramento.
      keep_alive: em,
    });
    if (totem.exists() && totem.data().compra_atual?.id === compraId) {
      transaction.update(totemRef, {
        keep_alive: em,
        "compra_atual.etapa": "EXPIROU",
        "compra_atual.keep_alive": em,
      });
    }
    return true;
  });
}
